module.exports = __webpack_public_path__ + "img/logo.e5db4fa9.svg";